const apiConfig = {
    serverUrl: 'https://aryadiet.com/api/', // آدرس سرور
  };
  // https://mohammadnrz-dev.com/api/
  // https://aryadiet.com/api/
  // http://localhost:8000/api/
  export default apiConfig;